// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-4a39fa4c]:export{siteFontFamily:system-ui,sans-serif,math,ui-rounded,ui-monospce}.collapse-edit-warp .collapse-layout-method__wrapper[data-v-4a39fa4c]{background:hsla(0,0%,100%,.05);margin-top:.5rem;padding:.5rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
